import React from 'react'
import PropTypes from 'prop-types'

import { currency_options } from '/models/commission-code'

import ReactSelect  from '/components/react-select'

export default \
class CurrencySelect extends React.Component

  render: ->
    <ReactSelect
      className="filter-selector state-selector"
      options={currency_options}
      multi={false}
      clearable={false}
      onChange={(event) => @props.onChange(event.value)}
      value={@props.value}
      placeholder="Select one"
      required
    />
